"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}
/* ++++++++++ --------------- EXPORT : TITLE : STYLES --------------- ++++++++++ */


var _default = _defineProperty({
  title: {
    color: _index.theme.color.supporting.dark.swatch,
    margin: '0 auto',
    position: 'relative',
    '& h1, h2, h3, h4, h5': {
      extend: _index.theme.typography.size.large,
      fontWeight: 'normal',
      marginBottom: (0, _index.pxToRem)(10),
      '& .tip': {
        fontSize: '50%'
      }
    },
    // variants
    // this is used on the account settings pages (like users) and also in embed analytics
    '&.variant-withctas': {
      width: '100%',
      minHeight: (0, _index.pxToEm)(50),
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      alignContent: 'center',
      marginBottom: (0, _index.pxToEm)(10),
      '& h2, h3, h4, h5': {
        extend: _index.theme.typography.size.medium,
        marginBottom: '0',
        marginRight: (0, _index.pxToEm)(20)
      },
      '& .name-discardchanges': {
        marginRight: (0, _index.pxToEm)(10)
      },
      '& .button': {
        width: (0, _index.pxToEm)(213)
      }
    },
    '&.variant-withtip': {
      display: 'flex',
      alignItems: 'center' // '& h2, h3, h4, h5': { extend: theme.typography.size.medium, marginBottom: '0' }

    },
    // names
    '&.name-numberof': {
      '& .total': {
        marginRight: (0, _index.pxToEm)(20)
      },
      '& .filtered': {
        color: _index.theme.color.primary.medium.swatch,
        opacity: '0',
        animationName: 'fadeInUp',
        animationDuration: '.2s',
        animationDelay: '0s',
        animationFillMode: 'forwards'
      }
    },
    // generates classes for every size in the theme ".size-(uniqueColor)"
    extend: (0, _index.themeStyleHelper)(_index.theme.typography, 'size', function (theme, uniqueProp) {
      return {
        '& h1, h2, h3, h4, h5': {
          extend: theme.size[uniqueProp]
        }
      };
    })
  }
}, _index.mediaQuery.thinnest, {
  title: {
    '&.variant-withctas': {
      '& .ctas': {
        marginTop: (0, _index.pxToRem)(5)
      }
    }
  }
});

exports.default = _default;